import React from "react";
import { MODES } from "../../../lib/initialAssessmentAdmin";

/**
 * How a group gets the initial assessment: Automat, Manual, or not through
 * the platform (with an optional note). Used in the portal's opening dialog
 * and on the group's sheet, so the two always offer the same three.
 */
export default function ModeChoice({ value, note, onChange, onNote, disabled, name = "assessment-mode" }) {
  return (
    <fieldset className="grid gap-2" disabled={disabled} data-testid="assessment-mode-choice">
      {MODES.map((m) => (
        <label key={m.key}
          className={`flex cursor-pointer items-start gap-2 rounded-xl border px-3 py-2 text-sm ${value === m.key
            ? "border-[#965EA7] bg-[#F0E7F4]/60" : "border-[#E5E7EB] bg-white hover:border-[#965EA7]/50"}`}>
          <input type="radio" name={name} value={m.key} checked={value === m.key} onChange={() => onChange(m.key)}
            className="mt-1 accent-[#965EA7]" data-testid={`assessment-mode-${m.key}`} />
          <span className="min-w-0">
            <strong className="text-[#373A45]">{m.label}:</strong> <span className="text-[#4B5160]">{m.hint}</span>
            {m.key === "external" && value === "external" && (
              <input type="text" value={note || ""} maxLength={200} onChange={(e) => onNote(e.target.value)}
                placeholder="Notă, opțional: unde și când a completat-o"
                className="mt-2 block w-full rounded-lg border border-[#E5E7EB] px-2.5 py-1.5 text-sm outline-none focus:ring-2 focus:ring-[#965EA7]"
                data-testid="assessment-mode-note" />
            )}
          </span>
        </label>
      ))}
    </fieldset>
  );
}
